import { render, staticRenderFns } from "./VehicleTypes.vue?vue&type=template&id=624ea2c0&scoped=true&"
import script from "./VehicleTypes.vue?vue&type=script&lang=js&"
export * from "./VehicleTypes.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTypes.vue?vue&type=style&index=0&id=624ea2c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624ea2c0",
  null
  
)

export default component.exports